import { getDefaultMargin, getDefaultMarginOverlay, getDefaultWidthOverlay } from '../utils'

export const LocationDesignSettings = {
  'location-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'location-design-height': {
    phone: [400],
    'phone-landscape': [400],
    tablet: [400],
    'tablet-landscape': [400],
    desktop: [400],
    tv: [400],
  },
  'location-design-aspect-ratio': {
    phone: '9:16',
    'phone-landscape': '16:9',
    tablet: '3:4',
    'tablet-landscape': '4:3',
    desktop: '16:9',
    tv: '16:9',
  },
  'location-design-alignment': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'location-design-shape': {
    phone: 'none',
    'phone-landscape': 'none',
    tablet: 'none',
    'tablet-landscape': 'none',
    desktop: 'none',
    tv: 'none',
  },
  'location-design-padding': {
    phone: getDefaultMargin([0]),
    'phone-landscape': getDefaultMargin([0]),
    tablet: getDefaultMargin([0]),
    'tablet-landscape': getDefaultMargin([0]),
    desktop: getDefaultMargin([0]),
    tv: getDefaultMargin([0]),
  },
  'location-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  'multi-location-design-width': {
    phone: ['100%'],
    'phone-landscape': ['50%'],
    tablet: ['100%'],
    'tablet-landscape': ['50%'],
    desktop: ['50%'],
    tv: ['50%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'multi-location-design-height': {
    phone: [400],
    'phone-landscape': [400],
    tablet: [400],
    'tablet-landscape': [400],
    desktop: [400],
    tv: [400],
  },
  'multi-location-design-aspect-ratio': {
    phone: '9:16',
    'phone-landscape': '16:9',
    tablet: '3:4',
    'tablet-landscape': '4:3',
    desktop: '16:9',
    tv: '16:9',
  },
  'multi-location-design-alignment': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'multi-location-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
  },
  'location-design-scheme': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'location-design-color-marker': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'multi-location-design-scheme': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'multi-location-design-color-marker': {
    dark: 'primary-90',
    light: 'primary-90',
  },
}
